<template>
  <tea-main @back="goBack">
    <template slot="nav">
      <div class="recordNav">
        <p>
          资质详情<span
            v-if="
              ['system', 'super', 'sysFive', 'supFive','viewer','viewFive'].includes(member_type)
            "
            >&nbsp;&nbsp;&nbsp;（#{{ recordInfo.record_id }}）</span
          >
        </p>
        <div style="display: flex">
          <template
            v-if="
              ['system', 'super', 'sysFive', 'supFive','viewer','viewFive'].includes(member_type)
            "
          >
            <el-select
              v-model="record_id"
              style="margin-right: 20px"
              v-if="recordList.length > 1"
              @change="changeQua($event)"
            >
              <el-option
                v-for="(item, index) in recordList"
                :key="index"
                :label="showLevel(item.levels) + getStatus(item.status)"
                :value="item.record_id"
              >
              </el-option>
            </el-select>
          </template>
          <p
            class="audit"
            @click="verify"
            v-if="
              recordInfo.status === 'audit' &&
              ['system', 'super', 'sysFive', 'supFive'].includes(member_type)
            "
          >
            审核资质
          </p>
          <p
            class="audit"
            @click="continu_improve"
            v-if="
              recordInfo.status === 'perfect' &&
              (showInfo ||
                member_type === 'expireStudent' ||
                member_type === 'expFive')
            "
          >
            继续完善
          </p>
          <p
            class="audit"
            @click="jumpLogin"
            v-if="showInfo && recordInfo.status === 'pass'"
          >
            登录
          </p>
          <p
            class="audit"
            v-if="
              recordInfo.status === 'audit' &&
              member_type !== 'system' &&
              member_type !== 'super' &&
              member_type !== 'viewer' &&
              isShowSelectForEducation &&
              the_quality !== 'futsal'
            "
            @click="enterEnroll"
          >
            此申请是否用于此次报名
          </p>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="recordMain">
        <yioks-loading v-show="loading"></yioks-loading>
        <div v-if="!loading" class="Info">
          <vue-scroll :ops="ops" ref="vs">
            <div
              class="mainInfo"
              v-if="
                auditData.length > 0 ||
                recordInfo.user_name ||
                infoData.length > 0
              "
            >
              <template v-if="auditData.length > 0">
                <div
                  class="title"
                  style="display: flex; justify-content: space-between"
                >
                  <div style="display: flex">
                    <v-icon
                      class="logo"
                      name="regular/clock"
                      scale="1.6"
                    ></v-icon>
                    <p class="titleInfo">资质审核过程</p>
                  </div>
                  <template
                    v-if="['system', 'super', 'sysFive', 'supFive'].includes(member_type)"
                  >
                    <div
                      style="
                        display: flex;
                        justify-content: flex-end;
                        width: 240px;
                      "
                    >
                      <div
                        class="zuxie-btn"
                        @click="deleteBlacklist(blacklistInfo.black_id)"
                        v-if="blacklistInfo.black_id"
                      >
                        移出处罚名单
                      </div>
                      <div
                        class="zuxie-btn"
                        @click="showAddBlackListDialog = true"
                        v-else
                      >
                        加入处罚名单
                      </div>
                      <template v-if="blacklistInfo.black_id">
                        <div
                          class="zuxie-btn"
                          style="margin-left: 10px"
                          @click="viewBlack"
                        >
                          查看处罚名单
                        </div>
                      </template>
                    </div>
                  </template>
                  <template
                    v-if="['viewer','viewFive'].includes(member_type)"
                  >
                    <div
                      style="
                        display: flex;
                        justify-content: flex-end;
                        width: 240px;
                      "
                    >
                      <template v-if="blacklistInfo.black_id">
                        <div
                          class="zuxie-btn"
                          style="margin-left: 10px"
                          @click="viewBlack"
                        >
                          查看处罚名单
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
                <div class="timeline">
                  <div
                    class="timeline-item"
                    v-for="(audit, i) in auditData"
                    :key="audit.audit_id"
                  >
                    <div
                      class="item_tail"
                      v-show="i !== auditData.length - 1"
                    ></div>
                    <div
                      class="item_node"
                      v-if="audit.audit_type === 'audit_qua'"
                    >
                      {{ audit.status | auditStatus }}
                    </div>
                    <div class="item_node" v-else>提交</div>
                    <div class="item_wrap">
                      <div class="timestamp">
                        <span>{{ audit.create_time | time }}</span>
                        <!--                                               <span class="audit_people" v-if="audit.type ==='audit_score'">-->
                        <!--                            审核人：{{audit.unit_name | userRole}}（{{audit.user_name}}）-->
                        <!--                          </span>-->
                        <!--                                        <span class="audit_people" v-if="audit.audit_type==='submit_qua'">-->
                        <!--                              提交人：{{ audit.user_name }}-->
                        <!--                            </span>-->
                        <!--                                        <span class="audit_people" v-else>-->
                        <!--                                  审核人：{{ audit.user_name }}-->
                        <!--                              </span>-->
                      </div>
                      <div class="item_cont">
                        <p>
                          <span v-if="audit.audit_type === 'submit_qua'">
                            资质审核提交成功，正在审查。
                          </span>
                          <span v-else-if="audit.status === 'pass'">
                            资质入库
                          </span>
                          <span v-else-if="audit.status === 'confirm'">
                            资质确认
                          </span>
                          <span v-else> 审核 </span>
                          <span
                            v-if="
                              audit.audit_type !== 'submit_qua' &&
                              audit.msg_info
                            "
                          >
                            ：{{ audit.msg_info }}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="recordInfo.user_name">
                <template
                  v-if="
                    ['system', 'super', 'sysFive', 'supFive'].includes(
                      member_type
                    )
                  "
                >
                  <div class="title">
                    <v-icon class="logo" name="tags" scale="1.6"></v-icon>
                    <p class="titleInfo">审批标记</p>
                  </div>
                  <div style="margin-bottom: 10px">
                    <el-tag
                      :key="tag"
                      v-for="tag in dynamicTags"
                      closable
                      class="tag_tag"
                      style="margin: 5px"
                      effect="dark"
                      :disable-transitions="false"
                      @close="handleClose(tag)"
                    >
                      {{ tag }}
                    </el-tag>
                    <el-input
                      class="input-new-tag"
                      v-if="inputVisible"
                      v-model.trim="inputValue"
                      ref="saveTagInput"
                      size="small"
                      @keyup.enter.native="handleInputConfirm"
                      @blur="handleInputConfirm"
                    >
                    </el-input>
                    <el-button
                      v-else
                      class="button-new-tag"
                      size="small"
                      @click="showInput"
                      >添加标记</el-button
                    >
                  </div>
                </template>
                <div class="title" style="justify-content: space-between">
                  <div style="display: flex">
                    <v-icon class="logo" name="user" scale="1.6"></v-icon>
                    <p class="titleInfo">
                      个人信息
                      <span
                        v-if="
                          ['system', 'super', 'sysFive', 'supFive','viewer','viewFive'].includes(
                            member_type
                          )
                        "
                        >（{{ userType(recordInfo.user_type) }}）</span
                      >
                    </p>
                  </div>
                  <template
                    v-if="['system', 'super', 'sysFive', 'supFive'].includes(member_type)"
                  >
                    <div
                      style="
                        display: flex;
                        justify-content: flex-end;
                        width: 240px;
                      "
                    >
                      <div class="zuxie-btn" @click="addFunc">添加文件存档</div>
                      <div
                        v-if="isDocumentExit"
                        class="zuxie-btn"
                        style="margin-left: 10px"
                        @click="viewDocuments"
                      >
                        查看文件存档
                      </div>
                    </div>
                  </template>
                  <template
                    v-if="['viewer','viewFive'].includes(member_type)"
                  >
                    <div
                      style="
                        display: flex;
                        justify-content: flex-end;
                        width: 240px;
                      "
                    >
                      <div
                        v-if="isDocumentExit"
                        class="zuxie-btn"
                        style="margin-left: 10px"
                        @click="viewDocuments"
                      >
                        查看文件存档
                      </div>
                    </div>
                  </template>
                </div>
                <div class="perInfo">
                  <template v-if="recordInfo.user_type === 'user'">
                    <el-row class="score-row">
                      <el-col :span="12" class="score-col">
                        <p>姓名(中文)：{{ recordInfo.user_name }}</p>
                      </el-col>
                      <el-col :span="12" class="score-col">
                        <p>证件号：{{ recordInfo.id_number }}</p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="8" class="score-col">
                        <p>手机号：{{ recordInfo.mobile_phone || "--" }}</p>
                      </el-col>
                      <el-col :span="8" class="score-col">
                        <p>提交时间：{{ recordInfo.create_time | time }}</p>
                      </el-col>
                      <el-col :span="8" class="score-col">
                        <p>审核状态：{{ recordInfo.status | auditStatus }}</p>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else>
                    <el-row class="score-row">
                      <el-col :span="8" class="score-col" style="padding: 10px">
                        <img
                          :src="recordInfo.profile_picture"
                          alt=""
                          style="width: 130px; height: 150px"
                          @error="imgError('photo')"
                        />
                      </el-col>
                      <el-col :span="8" class="score-col" style="padding: 10px">
                        <img
                          :src="recordInfo.id_card_photo_front"
                          alt=""
                          style="width: 270px; height: 150px"
                          @error="imgError('front')"
                        />
                      </el-col>
                      <el-col :span="8" class="score-col" style="padding: 10px">
                        <img
                          :src="recordInfo.id_card_photo_verso"
                          alt=""
                          style="width: 270px; height: 150px"
                          @error="imgError('verson')"
                        />
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="12" class="score-col">
                        <p>姓名(中文)：{{ recordInfo.user_name }}</p>
                      </el-col>
                      <el-col :span="12" class="score-col">
                        <p v-if="recordInfo.family_name_spell">
                          姓名(拼音)：{{ recordInfo.family_name_spell }}
                          {{ recordInfo.given_name_spell }}
                        </p>
                        <p v-else>姓名(拼音)：--</p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="12" class="score-col">
                        <p>手机号：{{ recordInfo.mobile_phone }}</p>
                      </el-col>
                      <el-col :span="12" class="score-col">
                        <p>证件号：{{ recordInfo.id_number }}</p>
                      </el-col>
                    </el-row>
                    <el-row class="score-row">
                      <el-col :span="12" class="score-col">
                        <p>提交时间：{{ recordInfo.create_time | time }}</p>
                      </el-col>
                      <el-col :span="12" class="score-col">
                        <p>审核状态：{{ recordInfo.status | auditStatus }}</p>
                      </el-col>
                    </el-row>
                  </template>
                </div>
              </template>
              <div class="title" v-if="the_quality !== 'futsal'">
                <v-icon class="logo" name="tags" scale="1.6"></v-icon>
                <p class="titleInfo" style="margin-bottom: 15px">
                  此申请是否用于本年度教练员继续教育报名 ：
                  {{ recordInfo.education_level | levelFilter }}
                </p>
              </div>
              <div class="title" v-if="the_quality !== 'futsal'">
                <v-icon class="logo" name="tags" scale="1.6"></v-icon>
                <p class="titleInfo" style="margin-bottom: 15px">
                  此申请是否用于本年度教练员等级培训报名 ：
                  {{ recordInfo.train_level | levelFilter }}
                </p>
              </div>
              <template v-if="infoData.length > 0">
                <div class="title">
                  <v-icon
                    class="logo"
                    name="regular/address-book"
                    scale="1.6"
                  ></v-icon>
                  <p class="titleInfo" style="color: red">待审核资质信息</p>
                </div>
                <div
                  class="recordInfo"
                  v-for="(item, index) in infoData"
                  :key="index"
                >
                  <el-row class="score-row">
                    <el-col :span="12" class="score-col">
                      <p>培训类型：{{ item.train_type | peixun_type }}</p>
                    </el-col>
                    <el-col :span="12" class="score-col">
                      <p>
                        级别：{{
                          item.train_level | levelForDoubleRole(the_quality)
                        }}
                      </p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row">
                    <el-col :span="12" class="score-col">
                      <p>
                        证明材料：
                        <span v-if="item.material_url" style="color: #4cd964"
                          ><a target="_blank" :href="item.material_url"
                            >（点击查看证明材料）</a
                          >
                        </span>
                        <span v-else>暂未上传证明材料</span>
                      </p>
                    </el-col>
                    <el-col :span="12" class="score-col">
                      <p>主讲师：{{ item.train_teacher || "--" }}</p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row">
                    <el-col :span="12" class="score-col">
                      <p>培训开始月份：{{ item.train_start || "--" }}</p>
                    </el-col>
                    <el-col :span="12" class="score-col">
                      <p>培训结束月份：{{ item.train_end || "--" }}</p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row">
                    <el-col :span="12" class="score-col">
                      <p>证书编号：{{ item.certificate_num || "--" }}</p>
                    </el-col>
                    <el-col :span="12" class="score-col">
                      <p>举办方：{{ item.train_org || "--" }}</p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row">
                    <el-col :span="12" class="score-col">
                      <p>培训区域：{{ trainingRegionType(item.region) }}</p>
                    </el-col>
                    <el-col :span="12" class="score-col">
                      <p>培训地点：{{ item.train_address || "--" }}</p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row">
                    <el-col :span="24" class="score-col">
                      <p>备注：{{ item.remark || "--" }}</p>
                    </el-col>
                  </el-row>
                </div>
                <template v-if="list.length > 0">
                  <fieldset class="intro_data">
                    <legend>原始数据</legend>
                  </fieldset>
                  <!-- 等级教练员执照 -->
                  <template
                    v-if="
                      coachHistoryInfo.coachUser.coachLicenseNumber &&
                      coachHistoryInfo.coachUser.coachRankType && !isFive
                    "
                  >
                    <div class="title">
                      <v-icon
                        class="logo"
                        name="regular/address-book"
                        scale="1.6"
                      ></v-icon>
                      <p class="titleInfo">等级教练员执照</p>
                    </div>
                    <div class="recordInfo">
                      <el-row class="score-row">
                        <el-col :span="7" class="score-col">
                          <p>
                            等级：{{
                              coachHistoryInfo.coachUser.coachRankType | level
                            }}
                          </p>
                        </el-col>
                        <el-col :span="9" class="score-col">
                          <p>
                            执照编号：{{
                              coachHistoryInfo.coachUser.coachLicenseNumber ||
                              "--"
                            }}
                          </p>
                        </el-col>
                        <el-col :span="8" class="score-col">
                          <p>
                            有效期至：{{
                              coachHistoryInfo.coachUser.coachLicenseEnd || "--"
                            }}
                          </p>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                  <!-- 守门员教练员执照 -->
                  <template
                    v-if="
                      coachHistoryInfo.coachUser.coachRankSpecialType &&
                      ['GA', 'GB', 'GC'].includes(
                        coachHistoryInfo.coachUser.coachRankSpecialType
                      ) &&
                      coachHistoryInfo.coachUser.coachLicenseNumber && !isFive
                    "
                  >
                    <div class="title">
                      <v-icon
                        class="logo"
                        name="regular/address-book"
                        scale="1.6"
                      ></v-icon>
                      <p class="titleInfo">守门员教练员执照</p>
                    </div>
                    <div class="recordInfo">
                      <el-row class="score-row">
                        <el-col :span="7" class="score-col">
                          <p>
                            等级：{{
                              coachHistoryInfo.coachUser.coachRankSpecialType
                                | level
                            }}
                          </p>
                        </el-col>
                        <el-col :span="9" class="score-col">
                          <p>
                            执照编号：{{
                              coachHistoryInfo.coachUser.coachLicenseNumber ||
                              "--"
                            }}
                          </p>
                        </el-col>
                        <el-col :span="8" class="score-col">
                          <p>
                            有效期至：{{
                              coachHistoryInfo.coachUser
                                .coachGoalieLicenseEnd || "--"
                            }}
                          </p>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                  <!-- 体能教练员执照 -->
                  <template
                    v-if="
                      coachHistoryInfo.coachUser.coachRankPhysicalType &&
                      ['F1', 'F2'].includes(
                        coachHistoryInfo.coachUser.coachRankPhysicalType
                      ) &&
                      coachHistoryInfo.coachUser.coachPhysicalLicenseEnd &&
                      coachHistoryInfo.coachUser.coachLicenseNumber && !isFive
                    "
                  >
                    <div class="title">
                      <v-icon
                        class="logo"
                        name="regular/address-book"
                        scale="1.6"
                      ></v-icon>
                      <p class="titleInfo">体能教练员执照</p>
                    </div>
                    <div class="recordInfo">
                      <el-row class="score-row">
                        <el-col :span="7" class="score-col">
                          <p>
                            等级：{{
                            coachHistoryInfo.coachUser.coachRankPhysicalType
                            | level
                            }}
                          </p>
                        </el-col>
                        <el-col :span="9" class="score-col">
                          <p>
                            执照编号：{{
                            coachHistoryInfo.coachUser.coachLicenseNumber ||
                            "--"
                            }}
                          </p>
                        </el-col>
                        <el-col :span="8" class="score-col">
                          <p>
                            有效期至：{{
                            coachHistoryInfo.coachUser
                            .coachPhysicalLicenseEnd || "--"
                            }}
                          </p>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                  <!-- 等级继续教育学时汇总 -->
                  <template
                    v-if="
                      coachHistoryInfo.coachUser.continueCumulativeHoursCount && !isFive
                    "
                  >
                    <div class="title">
                      <v-icon
                        class="logo"
                        name="regular/address-book"
                        scale="1.6"
                      ></v-icon>
                      <p class="titleInfo">继续教育学时汇总</p>
                    </div>
                    <div class="recordInfo">
                      <el-row class="score-row">
                        <el-col :span="7" class="score-col">
                          <p>
                            等级：{{
                              coachHistoryInfo.coachUser.coachRankType | level
                            }}
                          </p>
                        </el-col>
                        <el-col :span="9" class="score-col">
                          <p>
                            已获得学时：{{
                              coachHistoryInfo.coachUser
                                .continueCumulativeHoursCount || "--"
                            }}
                            &nbsp;&nbsp;&nbsp;未完成学时：{{coachHistoryInfo.coachUser.coachRankType | coachHoursALL(coachHistoryInfo.coachUser.continueCumulativeHoursCount) }}
                          </p>
                        </el-col>
                        <el-col :span="8" class="score-col">
                          <p>
                            学时有效期至：{{
                              coachHistoryInfo.coachUser.continueCreateDate
                                | continueEndDate
                            }}
                          </p>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                  <!-- 守门员继续教育学时汇总 continueGoalieCumulativeHoursCount continueGoalieCumulativeHoursCount -->
                  <template
                    v-if="
                      coachHistoryInfo.coachUser.continueGoalieCumulativeHoursCount && !isFive
                    "
                  >
                    <div class="title">
                      <v-icon
                        class="logo"
                        name="regular/address-book"
                        scale="1.6"
                      ></v-icon>
                      <p class="titleInfo">守门员继续教育学时汇总</p>
                    </div>
                    <div class="recordInfo">
                      <el-row class="score-row">
                        <el-col :span="7" class="score-col">
                          <p>
                            等级：{{
                              coachHistoryInfo.coachUser.coachRankSpecialType
                                | level
                            }}
                          </p>
                        </el-col>
                        <el-col :span="9" class="score-col">
                          <p>
                            已获得学时：{{
                              coachHistoryInfo.coachUser
                                .continueGoalieCumulativeHoursCount || "--"
                            }}
                            &nbsp;&nbsp;&nbsp;未完成学时：{{
                              32 -
                              coachHistoryInfo.coachUser
                                .continueGoalieCumulativeHoursCount
                            }}
                          </p>
                        </el-col>
                        <el-col :span="8" class="score-col">
                          <p>
                            学时有效期至：{{
                              coachHistoryInfo.coachUser
                                .continueGoalieCreateDate | continueEndDate
                            }}
                          </p>
                        </el-col>
                      </el-row>
                    </div>
                  </template>

                  <template>
                    <div class="title">
                      <v-icon
                        class="logo"
                        name="regular/address-book"
                        scale="1.6"
                      ></v-icon>
                      <p class="titleInfo">培训历程</p>
                    </div>
                    <div class="tbodyWrap">
                      <div class="tbody">
                        <div
                          class="tr"
                          v-for="(item, index) in list"
                          :key="index"
                        >
                          <div class="td detail" v-if="!item.is_old && !item.is_education">
                            <p
                              class="title"
                              @click="lookClassDetail(item.c_id)"
                            >
                              <span v-if="item.is_special_train === 1"
                                >【快】</span
                              >
                              {{ item.name }}
                            </p>
                            <div class="blockWrap">
                              <div class="left">
                                <div class="wrap">
                                  <div class="imgWrap">
                                    <img
                                      :src="
                                        !item.moment_picture
                                          ? classSrc
                                          : item.moment_picture
                                      "
                                      @error="imgListErr(index)"
                                      alt
                                    />
                                    <yioks-status
                                      :status="item.status"
                                    ></yioks-status>
                                  </div>
                                  <div class="infoWrap">
                                    <p>
                                      培训日期：{{
                                        item.start_date | time(false)
                                      }}
                                      至 {{ item.end_date | time(false) }}
                                    </p>
                                    <p v-if="item.class_level === 'E'">
                                      培训班级别：D级助理 （{{
                                        item.class_train_type
                                          | classTypeFilter(isFive)
                                      }}）
                                    </p>
                                    <p
                                      v-else-if="
                                        ['GC', 'GB', 'GA','F1','F2','PRO'].includes(
                                          item.class_level
                                        )
                                      "
                                    >
                                      培训班级别：{{
                                        item.class_level
                                          | classInfoBoxLevelFilter(isFive)
                                      }}
                                      （{{
                                        item.class_train_type
                                          | classTypeFilter(isFive)
                                      }}）
                                    </p>
                                    <p v-else>
                                      培训班级别：{{
                                        item.class_level
                                          | classInfoBoxLevelFilter(isFive)
                                      }}级 （{{
                                        item.class_train_type
                                          | classTypeFilter(isFive)
                                      }}）
                                    </p>
                                    <p>
                                      主讲师：{{
                                        item.teacher_off_name
                                          ? item.teacher_off_name
                                          : "足协指派"
                                      }}
                                    </p>
                                    <p v-if="item.teacher_name">
                                      助理讲师：{{ item.teacher_name }}
                                    </p>
                                    <p v-if="item.intern_teacher != ''">
                                      实习讲师：{{ item.intern_teacher }}
                                    </p>
                                    <p
                                      v-if="item.lecturer_assistant_name != ''"
                                    >
                                      讲师助理：{{
                                        item.lecturer_assistant_name
                                      }}
                                    </p>
                                    <p
                                      v-if="item.teacher_zhuli_names != ''"
                                    >
                                      讲师助理：{{
                                        item.teacher_zhuli_names
                                      }}
                                    </p>
                                    <p v-if="item.hours">
                                      学时：{{ item.hours }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="right">
                                <div
                                  class="btn"
                                  @click="lookStuDetail(item.c_id)"
                                >
                                  <p>培训历程</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="td detail" v-if="!item.is_old && item.is_education">
                            <p
                              class="title"
                              @click="lookEducationDetail(item.edu_id)"
                            >
                              {{ item.name }}
                            </p>
                            <div class="blockWrap">
                              <div class="left">
                                <div class="wrap">
                                  <div class="imgWrap">
                                    <img
                                      :src="
                                        !item.moment_picture
                                          ? classSrc
                                          : item.moment_picture
                                      "
                                      @error="imgListErr(index)"
                                      alt
                                    />
                                    <yioks-status :status="item.status" :type="`education`"></yioks-status>
                                  </div>
                                  <div class="infoWrap">
                                    <p>
                                      学习日期：{{
                                      item.start_date | time(false)
                                      }}
                                      至 {{ item.end_date | time(false) }}
                                    </p>
                                    <!-- classType -->
                                    <p v-if="item.level === 'E'">级别：D级助理 <span style="font-size: 14px">（{{item.education_type | classTypeFilter(isFive)}}）</span></p>
                                    <p v-else-if="['GC', 'GB', 'GA','F1','F2','PRO' ].includes( item.level)">级别：{{item.level | classInfoBoxLevelFilter(isFive)}} （{{item.education_type | classTypeFilter(isFive)}}）</p>
                                    <p v-else>级别：{{item.level | classInfoBoxLevelFilter(isFive)}}级（{{item.education_type | classTypeFilter(isFive)}}）</p>
    
                                    <p >
                                      学时：{{ item.hours || '--' }}
                                    </p>
                                    <p>
                                      学习状态：{{item.study_status | educationLearnStatusFilter}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="right" v-if="['Incomplete','Complete','Finalised'].includes(item.status)">
                                <div class="btn" @click="lookEducationStudy(item.edu_id)">
                                  <p>查看详情</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="rankInfo" v-if="item.is_old">
                            <el-row class="score-row">
                              <el-col :span="12" class="score-col">
                                <p>
                                  等级：{{ item | coachHistoryFilter }}
                                </p>
                              </el-col>
                              <el-col :span="12" class="score-col">
                                <!--                            如果成绩状态为有效，则显示通过，其他正常显示    -->
                                <p>
                                  通过状态：{{
                                    item.coachRankStatus == "有效"
                                      ? "通过"
                                      : item.coachRankStatus
                                  }}<span v-if="item.coachRankTypeStatus">({{item.coachRankTypeStatus}})</span>
                                </p>
                              </el-col>
                            </el-row>
                            <el-row class="score-row">
                              <el-col :span="12" class="score-col">
                                <p>所属年份：{{ item.coachRankYear }}年</p>
                              </el-col>
                              <el-col :span="12" class="score-col">
                                <p>讲师：{{ item.lecturerName || "--" }}</p>
                              </el-col>
                            </el-row>
                            <el-row class="score-row">
                              <el-col :span="12" class="score-col">
                                <p>举办方：{{ item.coachRankOrgan || "--" }}</p>
                              </el-col>
                              <el-col :span="12" class="score-col">
                                <p>培训地点：{{ item.classAddress || "--" }}</p>
                              </el-col>
                            </el-row>
                            <el-row class="score-row">
                              <el-col :span="12" class="score-col">
                                <p>
                                  培训开始时间：{{ item.classStart || "--" }}
                                </p>
                              </el-col>
                              <el-col :span="12" class="score-col">
                                <p>培训结束时间：{{ item.classEnd || "--" }}</p>
                              </el-col>
                            </el-row>
                            <el-row
                              class="score-row"
                              v-if="item.coachRankStatus == '有效'"
                            >
                              <el-col :span="12" class="score-col">
                                <p>
                                  证书编号：{{ item.certificateNum || "--"
                                  }}<span
                                    v-if="item.certificateUrl"
                                    style="cursor: pointer; color: #4cd964"
                                    ><a
                                      target="_blank"
                                      :href="item.certificateUrl"
                                      >（查看电子证书）</a
                                    ></span
                                  >
                                </p>
                              </el-col>
                              <el-col :span="12" class="score-col">
                                <p>
                                  编号时间：{{ item.certificateDate || "--" }}
                                </p>
                              </el-col>
                            </el-row>
                            <!--                                            <el-row class="score-row" v-if="item.certificateUrl && (item.coachRankType ==='C' ||  item.coachRankType ==='D')">-->
                            <!--                                                <el-col :span="24" class="score-col">-->
                            <!--                                                    <p>执教执照正在生成中，电子证书暂时被锁定，执教执照生成后会自动恢复下载。</p>-->
                            <!--                                                </el-col>-->
                            <!--                                            </el-row>-->
                            <el-row class="score-row" v-if="item.score">
                              <div class="score-table">
                                <div class="row">
                                  <div
                                    class="score-col"
                                    v-for="item_score in item.score"
                                  >
                                    <p>
                                      {{ item_score.achievementSubjectTitle }}
                                    </p>
                                    <p>
                                      {{ item_score.achievementScore }}
                                      <span
                                        v-if="
                                          Number(item_score.achievementScore)
                                        "
                                        >分</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </el-row>
                            <template v-if="item.createCoachRank === 3">
                              <el-row
                                class="score-row bz"
                                v-if="item.coachRankStatus === '有效'"
                              >
                                <el-col :span="24" class="score-col">
                                  <p>
                                    2008年12月31日之前参加岗位培训的足球教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见<span
                                      style="color: #4cd964"
                                      ><a
                                        href="http://www.thecfa.cn/hitz/20190909/27995.html"
                                        target="_blank"
                                        >《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a
                                      ></span
                                    >
                                  </p>
                                </el-col>
                              </el-row>
                            </template>
                            <template v-else-if="item.createCoachRank === 4">
                              <el-row
                                class="score-row bz"
                                v-if="item.coachRankStatus === '有效'"
                              >
                                <el-col :span="24" class="score-col">
                                  <p>
                                    教练员在国外获得的教练员等级证书或在国内参加国外驻华或来华机构举办的教练员培训班获得的等级证书，通过中国足协认证后仅颁发新的执教执照，不再颁发新的电子证书。
                                  </p>
                                </el-col>
                              </el-row>
                            </template>
                            <template v-else>
                              <el-row
                                class="score-row bz"
                                v-if="
                                  item.coachRankStatus === '有效' &&
                                  (item.coachRankPhysicalType === 'F1' || item.coachRankPhysicalType === 'F2') &&
                                  Number(item.coachRankYear) < 2022
                                "
                              >
                                <el-col :span="24" class="score-col">
                                  <p>
                                    2021年12月31日之前参加培训的体能L1级/体能L2级教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见<span
                                    style="color: #4cd964"
                                  ><a
                                    href="http://www.thecfa.cn/hitz/20190909/27995.html"
                                    target="_blank"
                                  >《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a
                                  ></span
                                  >
                                  </p>
                                </el-col>
                              </el-row>
                              <el-row
                                class="score-row bz"
                                v-if="
                                  item.coachRankStatus === '有效' &&
                                  item.coachRankType === 'D' &&
                                  Number(item.coachRankYear) < 2019
                                "
                              >
                                <el-col :span="24" class="score-col">
                                  <p>
                                    2018年12月31日之前参加培训的D级教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见<span
                                      style="color: #4cd964"
                                      ><a
                                        href="http://www.thecfa.cn/hitz/20190909/27995.html"
                                        target="_blank"
                                        >《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a
                                      ></span
                                    >
                                  </p>
                                </el-col>
                              </el-row>
                              <el-row
                                class="score-row bz"
                                v-else-if="
                                  item.coachRankStatus === '有效' &&
                                  item.coachRankType === 'early' &&
                                  Number(item.coachRankYear) < 2019
                                "
                              >
                                <el-col :span="24" class="score-col">
                                  <p>2018年12月31日之前参加培训的五人制足球初级教练员不颁发电子证书，无需提交缺失资质审核。</p>
                                </el-col>
                              </el-row>
                              <el-row
                                  class="score-row bz"
                                  v-else-if="
                                  item.coachRankStatus === '有效' &&
                                  item.coachRankType === 'L1' &&
                                  item.classTheQuality === 'futsal'
                                "
                              >
                                <el-col :span="24" class="score-col">
                                  <p>五人制足球L1级教练员暂时不颁发电子证书，无需提交缺失资质审核。</p>
                                </el-col>
                              </el-row>
                              <el-row
                                class="score-row bz"
                                v-else-if="
                                  item.certificateNum && !item.certificateUrl && !item.coachRankPhysicalType
                                "
                              >
                                <el-col :span="24" class="score-col">
                                  <p>
                                    电子证书正在制作中，请通过教练员培训管理系统查看个人执教资质。若急需证明文件，请联系注册协会，带来不便敬请谅解。
                                  </p>
                                </el-col>
                              </el-row>
                            </template>
                            <div
                              v-if="index !== list.length - 1"
                              class="dashed-line"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
            <div v-else>
              <yioks-empty
                tips="数据不存在，请返回上一步重新查询。"
              ></yioks-empty>
            </div>
          </vue-scroll>
        </div>
        <template v-if="verifyFlag">
          <yioks-verify
            :flag="verifyFlag"
            :verifyBtn="true"
            :banBtn="false"
            :isFive="isFive"
            :holderText="`如审核拒绝，可在此输入理由`"
            @hideVerify="hideVerifyDialog"
          ></yioks-verify>
        </template>

        <template v-if="showAddBlackListDialog">
          <BlackListDialog
            :showBlackListDialog="showAddBlackListDialog"
            :Info="{
              name: recordInfo.user_name,
              mobile_phone: recordInfo.mobile_phone,
              id_number: recordInfo.id_number,
              remark: '缺失资质#id' + recordInfo.record_id,
            }"
            @hideTips="hideBlackListTips"
          ></BlackListDialog>
        </template>
        <template v-if="showDeleteDialog">
          <yioks-dialog
            :showTips.sync="showDeleteDialog"
            :tips="`确定将${recordInfo.user_name}移出处罚名单吗?`"
            @hideTips="hideDeleteDialog"
          ></yioks-dialog>
        </template>
        <template v-if="isShowEnterEnroll && recordInfo.record_id">
          <edit-enter-enroll
            :enrollId="recordInfo.enroll_id"
            :education_level="recordInfo.education_level"
            :train_level="recordInfo.train_level"
            :recordId="recordInfo.record_id"
            :educationAvailable="isContinueAvailable"
            :trainAvailable="isTrainAvaiable"
            @hideTips="handleHideTips"
            :showdialog.sync="isShowEnterEnroll"
          ></edit-enter-enroll>
        </template>
        <template v-if="add_show">
          <add-dialog
            :showAddDialog="add_show"
            :Info="{
              name: recordInfo.user_name,
              id_number: recordInfo.id_number,
              mobile_phone: recordInfo.mobile_phone,
              remark: '缺失资质#id' + recordInfo.record_id,
            }"
            @hideTips="hideAddDocumentTips"
          ></add-dialog>
        </template>
      </div>
    </template>
  </tea-main>
</template>

<script>
import classSrc from "@/assets/images/class_logo.png";
import {
  coach_qualification_info,
  qualification_make_tag,
  getStuDetails,
  coach_qualification_audit,
  get_coach_by_puuid,
  coach_train_list,
  remove_blackList,
} from "@/api/system_manager/api";
import {
  qualification_JxPermission,
  checkEducationAndTrainAvaible,
} from "@/api/ab_signup/api";
import { getDocumentList } from "@/api/document/document";
import {
  LevelFilters,
  LevelFiltersFutsal,
  train_type,
  typeFilters,
} from "@/assets/js/status";
import { levelFilter, coachHistoryFilter,educationLearnStatusFilter,coachHoursALL } from "@/assets/js/yioksFilters";
import { storageData } from "@/assets/js/storage";
import ops from "@/assets/js/vuescrollOption";
import "vue-awesome/icons/user";
import "vue-awesome/icons/regular/address-book";
import "vue-awesome/icons/tags.js";
import "vue-awesome/icons/regular/clock";
import identify1 from "@/assets/images/vita/identify1.png";
import identify2 from "@/assets/images/vita/identify2.png";
import placePhoto from "@/assets/images/person.png";
import fiveMixins from "@/minix/fiveMixins";

export default {
  name: "record",
  mixins: [fiveMixins],
  data() {
    return {
      isDocumentExit: false,
      identify1,
      identify2,
      placePhoto,
      showInfo: false,
      showDeleteDialog: false,
      classSrc,
      black_id: "",
      isShowEnterEnroll: false,
      record_id: "",
      id_number: this.$route.query.id_number,
      user_type: this.$route.query.user_type,
      the_query_code: this.$route.query.the_query_code,
      user_id: this.$route.query.user_id,
      puuid: this.$route.query.puuid,
      userInfo: "",
      showHistory: false,
      add_show: false,
      continueEducationButtonValidity: false,
      list: [],
      coachHistoryInfo: {
        coachUser: {},
        ranks: [],
        certificates: [],
        achievemens: [],
        rankList: [],
      },
      curStuInfo: {
        studentSingnInfo: {},
        language_list: [],
        academic_data: [],
        coach_data: [],
        experience_data: [],
        playing_data: [],
      },
      recordInfo: {},
      enrollData: {},
      infoData: [],
      ops: ops(),
      recordList: [],
      auditData: [],
      blacklistInfo: {},
      member_type: "",
      loading: true,
      verifyFlag: false,
      showAddBlackListDialog: false,
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      isContinueAvailable: false,
      isTrainAvaiable: "",
      the_quality: "futsal",
    };
  },
  computed: {
    // 是否显示继续教育，等级培训筛选
    isShowSelectForEducation() {
      if (
        this.isContinueAvailable ||
        this.isTrainAvaiable == "A" ||
        this.isTrainAvaiable == "B"
      ) {
        return true;
      } else {
        return false;
      }
    },

    // the_quality() {
    //   const { the_quality } = this.$route.query;
    //   return the_quality;
    // },
  },
  created() {
    this.getEducationAndTrainAvaible();
    const member_type = storageData.getUserInfo().member_type;
    const token = storageData.getToken();
    this.member_type = member_type;
    this.showInfo = token ? false : true;
    if (this.puuid) {
      this.getIDNum();
    } else {
      this.request();
    }
    if (['system', 'super', 'sysFive', 'supFive','viewer','viewFive'].includes(member_type)) {
      this.checkDocumentExit();
    }
  },
  methods: {
    // 检查文件存档是否存在
    checkDocumentExit() {
      const { id_number } = this.$route.query;
      const params = {
        page: 1,
        keywords: "",
        id_number: id_number,
        object_type: "", // class organ
      };
      getDocumentList(params)
        .then(({ data }) => {
          if (data.status === 0) {
            const { page } = data.result;
            if (page.total_row) {
              this.isDocumentExit = true;
            } else {
              this.isDocumentExit = false;
            }
          } else {
            console.error("getDocumentList request error");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    viewBlack() {
      this.$router.push({
        path: "blacklist",
        query: {
          keywords: this.id_number,
          source: "qualification",
        },
      });
    },
    request(flag) {
      this.loading = true;
      coach_qualification_info({
        id_number: this.id_number,
        member_type: this.member_type,
        the_query_code: this.the_query_code,
      })
        .then((res) => {
          if (Number(res.data.status) === 0) {
            const {
              recordInfo,
              infoData,
              blacklistInfo,
              auditData,
              userInfo,
              recordList,
              enrollData,
            } = res.data.result;
            if (recordList.length > 0) this.recordList = recordList;
            this.blacklistInfo = blacklistInfo;
            if (recordInfo) this.recordInfo = recordInfo;
            if (enrollData) this.enrollData = enrollData;
            if (recordInfo && recordInfo.the_quality)
              this.the_quality = recordInfo.the_quality;
            if (recordInfo.record_tags) {
              this.dynamicTags = JSON.parse(recordInfo.record_tags);
            } else {
              this.dynamicTags = [];
            }

            this.record_id = recordInfo.record_id;
            if (userInfo) this.userInfo = userInfo;
            if (infoData.length > 0) this.infoData = infoData;
            if (auditData.length > 0) this.auditData = auditData;
            this.loading = false;
            if (
              ["system", "super", "sysFive", "supFive","viewer","viewFive"].includes(
                this.member_type
              )
            ) {
              if (!flag) {
                if (!this.showInfo) {
                  if (
                    this.recordInfo.user_type &&
                    this.recordInfo.user_type === "user"
                  ) {
                    this.getStuList();
                  } else if (
                    this.recordInfo.user_type &&
                    this.recordInfo.user_type === "tourists"
                  ) {
                    this.getStuListByIDNum();
                  }
                }
              }
            }
            this.getQualificationJxPermission();
          } else {
            this.loading = false;
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    getIDNum() {
      get_coach_by_puuid({
        puuid: this.puuid,
      })
        .then((res) => {
          if (Number(res.data.status) === 0) {
            const { id_number, the_query_code } = res.data.result;
            id_number && (this.id_number = id_number);
            the_query_code && (this.the_query_code = the_query_code);
            this.request(true);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    verify() {
      this.verifyFlag = true;
    },
    handleHideTips(bool, flag) {
      this.isShowEnterEnroll = bool;
      if (flag) {
        if (this.puuid) {
          this.getIDNum();
        } else {
          this.request();
        }
      }
    },
    hideVerifyDialog(bool, params, msg) {
      if (bool) {
        coach_qualification_audit({
          record_id: this.recordInfo.record_id,
          status: params,
          msg_info: msg,
        })
          .then((res) => {
            if (Number(res.data.status) === 0) {
              switch (params) {
                case "Y":
                  this.recordInfo.status = "pass";
                  break;
                case "N":
                  this.recordInfo.status = "refused";
                  break;
                case "P":
                  this.recordInfo.status = "perfect";
                  break;
              }
              this.verifyFlag = false;
              this.$message.success("资质审核成功");
              this.request(true);
              // this.$router.go(-1)
            } else {
              this.$message.error(res.data.msg);
              this.verifyFlag = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.verifyFlag = false;
          });
      } else {
        this.verifyFlag = false;
      }
    },
    continu_improve() {
      if (this.showInfo) {
        this.$router.push({
          path: "/editQualification",
          query: {
            id_number: this.id_number,
            the_query_code: this.the_query_code,
          },
        });
      } else {
        this.$router.push({
          path: "edit_qualification",
          query: {
            id_number: this.id_number,
            the_query_code: this.the_query_code,
          },
        });
      }
    },
    jumpLogin() {
      this.$router.push({
        path: "/login",
        query: {
          tmpUserName: this.id_number,
        },
      });
    },
    enterEnroll() {
      this.isShowEnterEnroll = true;
    },
    lookEducationStudy(c_id) {
      this.$router.push({
        path: "student_study_learn_view",
        query: {
          edu_id:c_id,
          stu_id: this.recordInfo.user_id
        }
      });
    },
    lookEducationDetail(c_id) {
      this.$router.push({
        path: "education_detail",
        query: {
          edu_id:c_id
        }
      });
    },
    getStuList() {
      getStuDetails({
        uid: this.userInfo,
      })
        .then((res) => {
          const { result } = res.data;

          this.list = result.list;
          // 处理历史培训数据
          if (result.coachHistoryInfo) {
            const { list } = result;
            const { coachUser, ranks, certificates, achievemens, score } =
              result.coachHistoryInfo;
            if (coachUser) this.coachHistoryInfo.coachUser = coachUser; // 获取用户信息
            if (ranks) this.coachHistoryInfo.ranks = ranks; // 获取等级
            if (certificates) this.coachHistoryInfo.certificates = certificates; //获取证书
            if (achievemens) this.coachHistoryInfo.achievemens = achievemens; //获取成绩信息

            // 处理证书
            let certificateInfo = {};
            if (certificates.length > 0) {
              for (let i = 0; i < certificates.length; i++) {
                const { rankId } = certificates[i];
                certificateInfo[rankId] = certificates[i];
              }
            }
            // 处理成绩
            let achievemensInfo = {};
            if (achievemens.length > 0) {
              for (let i = 0; i < achievemens.length; i++) {
                const { rankId } = achievemens[i];
                achievemensInfo[rankId] = achievemens[i];
              }
            }

            // 获取平台培训数据
            let coachTrainInfo = {};
            if (this.list.length > 0) {
              for (let i = 0; i < this.list.length; i++) {
                const { unique_code } = this.list[i];
                coachTrainInfo[unique_code] = this.list[i];
              }
            }
  
            // 平台内继续教育 判断uuid
            let educationInfo = {};
            if (result.educationData.length > 0) {
              for (let i = 0; i < result.educationData.length; i++) {
                const {uuid} = result.educationData[i];
                educationInfo[uuid] = result.educationData[i];
              }
            }

            // 合并成绩
            if (ranks.length > 0) {
              for (let j = 0; j < ranks.length; j++) {
                const { id } = ranks[j];
                ranks[j].is_old = 1;
                if (score && score[achievemensInfo[id]["id"]]) {
                  ranks[j]["score"] = score[achievemensInfo[id]["id"]];
                }
                if (certificateInfo[id]) {
                  const {
                    certificateNum,
                    certificateDate,
                    validityStart,
                    certificateUrl,
                  } = certificateInfo[id];
                  ranks[j].certificateNum = certificateNum;
                  ranks[j].certificateDate = certificateDate;
                  ranks[j].validityStart = validityStart;
                  if (certificateUrl) ranks[j].certificateUrl = certificateUrl;
                }
                if (achievemensInfo[id]) {
                  const {
                    classAddress,
                    classEnd,
                    classStart,
                    lecturerName,
                    classUid,
                  } = achievemensInfo[id];
                  ranks[j].classAddress = classAddress;
                  ranks[j].classEnd = classEnd;
                  ranks[j].classStart = classStart;
                  ranks[j].lecturerName = lecturerName;
                  ranks[j].classUid = classUid;
                  ranks[j].end_date = new Date(classEnd).getTime();
                  if (!coachTrainInfo[classUid]) {
                    if(ranks[j].createCoachRank === 5){
                      console.log(educationInfo)
                      if (!educationInfo[classUid]) {
                        this.list.push(ranks[j]);
                      }
                    }else{
                      this.list.push(ranks[j]);
                    }
                  }
                }
              }
            }
            // 按照培训结束日期进行排序
//            if (list)
//              this.list = list.sort((pre, next) => {
//                return next.end_date - pre.end_date;
//              });
//            this.showHistory = true;
          }
          // 处理继续教育
          if (result.educationData) {
            const {educationData} = result;
            if (educationData) this.educationData = educationData; // 继续教育
            console.log(educationData)
            // 合并成绩 // this.list中存储了当前平台中查询到的数据，现在将数据库中的数据push进list；
            if (educationData.length > 0) {
              for (let j = 0; j < educationData.length; j++) {
                educationData[j].is_education = 1;  // 注意ranks声明一个常量，幸好引用变量// ranks中的数据均来自数据库，为历史数据
                this.list.push(educationData[j]);
              }
            }
          }
          if (this.list.length > 0) {
            // 按照培训结束日期进行排序
            this.list = this.list.sort((pre, next) => {
              return next.end_date - pre.end_date;
            });
          } else {
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStuListByIDNum() {
      coach_train_list({
        id_number: this.id_number,
      })
        .then((res) => {
          const { result } = res.data;
          this.list = result.list;
          // 处理历史培训数据
          if (result.coachHistoryInfo) {
            const { list } = result;
            const { coachUser, ranks, certificates, achievemens, score } =
              result.coachHistoryInfo;
            if (coachUser) this.coachHistoryInfo.coachUser = coachUser; // 获取用户信息
            if (ranks) this.coachHistoryInfo.ranks = ranks; // 获取等级
            if (certificates) this.coachHistoryInfo.certificates = certificates; //获取证书
            if (achievemens) this.coachHistoryInfo.achievemens = achievemens; //获取成绩信息

            // 处理证书
            let certificateInfo = {};
            if (certificates.length > 0) {
              for (let i = 0; i < certificates.length; i++) {
                const { rankId } = certificates[i];
                certificateInfo[rankId] = certificates[i];
              }
            }
            // 处理成绩
            let achievemensInfo = {};
            if (achievemens.length > 0) {
              for (let i = 0; i < achievemens.length; i++) {
                const { rankId } = achievemens[i];
                achievemensInfo[rankId] = achievemens[i];
              }
            }

            // 获取平台培训数据
            let coachTrainInfo = {};
            if (this.list.length > 0) {
              for (let i = 0; i < this.list.length; i++) {
                const { unique_code } = this.list[i];
                coachTrainInfo[unique_code] = this.list[i];
              }
            }

            // 合并成绩
            if (ranks.length > 0) {
              for (let j = 0; j < ranks.length; j++) {
                const { id } = ranks[j];
                ranks[j].is_old = 1;
                if (score && score[achievemensInfo[id]["id"]]) {
                  ranks[j]["score"] = score[achievemensInfo[id]["id"]];
                }
                if (certificateInfo[id]) {
                  const {
                    certificateNum,
                    certificateDate,
                    validityStart,
                    certificateUrl,
                  } = certificateInfo[id];
                  ranks[j].certificateNum = certificateNum;
                  ranks[j].certificateDate = certificateDate;
                  ranks[j].validityStart = validityStart;
                  if (certificateUrl) ranks[j].certificateUrl = certificateUrl;
                }
                if (achievemensInfo[id]) {
                  const {
                    classAddress,
                    classEnd,
                    classStart,
                    lecturerName,
                    classUid,
                  } = achievemensInfo[id];
                  ranks[j].classAddress = classAddress;
                  ranks[j].classEnd = classEnd;
                  ranks[j].classStart = classStart;
                  ranks[j].lecturerName = lecturerName;
                  ranks[j].classUid = classUid;
                  ranks[j].end_date = new Date(classEnd).getTime();
                  if (!coachTrainInfo[classUid]) {
                    this.list.push(ranks[j]);
                  }
                }
              }
            }
            // 按照培训结束日期进行排序
            if (list)
              this.list = list.sort((pre, next) => {
                return next.end_date - pre.end_date;
              });
            this.showHistory = true;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    imgListErr(idx) {
      this.$set(this.list[idx], "moment_picture", this.imgSrc);
    },
    lookClassDetail(c_id) {
      this.$router.push({
        path: "class_detail",
        query: {
          c_id,
        },
      });
    },
    lookStuDetail(c_id) {
      this.$router.push({
        path: "tea_sd",
        query: {
          c_id,
          u_id: this.userInfo,
        },
      });
    },
    showLevel(level) {
      return level
        .replace("A", "A级")
        .replace("B", "B级")
        .replace("C", "C级")
        .replace("D", "D级")
        .replace("P", "职业级")
        .replace("初", "初级")
        .replace("中", "中级")
        .replace("高", "高级");
    },
    getStatus(status) {
      switch (status) {
        case "audit":
          status = "（待审核）";
          break;
        case "pass":
          status = "（通过）";
          break;
        case "refused":
          status = "（拒绝）";
          break;
        case "perfect":
          status = "（待完善）";
          break;
        default:
          status = "";
          break;
      }
      return status;
    },
    userType(type) {
      switch (type) {
        case "user":
          return "正式学员";
          break;
        case "tourists":
          return "待审核学员";
          break;
      }
    },
    trainingRegionType(type) {
      switch (type) {
        case "territory_of_China":
          return "中国大陆";
          break;
        case "HMT":
          return "港澳台";
          break;
        case "other":
          return "其他";
          break;
      }
    },
    changeQua(val) {
      this.recordList.forEach((item, index) => {
        if (Number(item.record_id) === Number(val)) {
          this.the_query_code = item.the_query_code;
          return;
        }
      });
      this.$router.replace({
        path: this.$route.path,
        query: {
          id_number: this.id_number,
          the_query_code: this.the_query_code,
          user_type: this.recordInfo.user_type,
        },
      });
      this.request(true);
    },
    hideBlackListTips(bool, flag) {
      this.showAddBlackListDialog = bool;
      if (flag) {
        this.$message.success("添加处罚人员成功！");
        this.request(true);
      }
    },
    deleteBlacklist(black_id) {
      this.black_id = black_id;
      this.showDeleteDialog = true;
    },
    addFunc() {
      this.add_show = true;
    },
    viewDocuments() {
      this.$router.push({
        path: "documents",
        query: {
          id_number: this.recordInfo.id_number,
        },
      });
    },
    hideAddDocumentTips(bool, flag) {
      this.add_show = bool;
      if (flag) {
        this.$message.success("添加成功！");
        this.checkDocumentExit();
      }
    },
    hideDeleteDialog(bool, flag) {
      if (flag) {
        remove_blackList({
          black_id: this.black_id,
        })
          .then((res) => {
            if (Number(res.data.status) === 0) {
              this.request(true);
              this.$message.success("移出处罚名单成功！");
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            this.showDeleteDialog = false;
          });
      }
      this.showDeleteDialog = bool;
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      qualification_make_tag({
        record_id: this.record_id,
        record_tags: JSON.stringify(this.dynamicTags),
      })
        .then((res) => {
          if (Number(res.data.status) === 0) {
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        qualification_make_tag({
          record_id: this.record_id,
          record_tags: JSON.stringify(this.dynamicTags),
        })
          .then((res) => {
            if (Number(res.data.status) === 0) {
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    imgError(type) {
      if (type === "photo") {
        this.$set(this.recordInfo, "profile_picture", this.placePhoto);
      } else if (type === "front") {
        this.$set(this.recordInfo, "id_card_photo_front", this.identify1);
      } else if (type === "verson") {
        this.$set(this.recordInfo, "id_card_photo_verso", this.identify2);
      }
    },
    getQualificationJxPermission() {
      qualification_JxPermission({
        id_number: this.id_number,
      })
        .then((res) => {
          if (Number(res.data.status) === 0) {
            const { continueEducationButtonValidity } = res.data.result;
            // 判断是否显示继续教育提交按钮
            if (
              !continueEducationButtonValidity &&
              this.recordInfo.levels !== "D"
            ) {
              this.continueEducationButtonValidity = true;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 检查等级培训、继续教育开放状态
    async getEducationAndTrainAvaible() {
      try {
        const { data } = await checkEducationAndTrainAvaible();
        if (data.status !== 0) {
          this.$message.error(data.msg);
        } else {
          const { is_education_level, is_train_level } = data.result;
          this.isContinueAvailable = !!Number(is_education_level);
          // this.isTrainAvaiable = !!Number(is_train_level);
          this.isTrainAvaiable = is_train_level;
        }
      } catch (err) {
        console.error("err", err);
      }
    },
  },
  filters: {
    coachHistoryFilter,
    educationLearnStatusFilter,
    auditStatus(status) {
      switch (status) {
        case "audit":
          status = "待审核";
          break;
        case "pass":
          status = "通过";
          break;
        case "refused":
          status = "拒绝";
          break;
        case "perfect":
          status = "待完善";
          break;
        case "confirm":
          status = "资质确认";
          break;
        default:
          status = "";
          break;
      }
      return status;
    },
    level(level) {
      if (!level) {
        return "--";
      }
      return LevelFilters(level);
      // return this.the_quality === 'futsal' ? LevelFiltersFutsal(level) : LevelFilters(level);
    },
    // 区分五人制
    levelForDoubleRole(level, type) {
      if (!level) {
        return "--";
      }
      if (type === "futsal") {
        return LevelFiltersFutsal(level);
      } else {
        return LevelFilters(level);
      }
      // return this.the_quality === 'futsal' ? LevelFiltersFutsal(level) : LevelFilters(level);
    },
    levelFilter,
    coachHoursALL,
    continueEndDate(dateText) {
      // 2022.08.19修改 学时有效期改为当年有效
      let date = new Date();
      return date.getFullYear() + "-12-31";
    },
    classType(level) {
      return typeFilters(level);
    },
    peixun_type(type) {
      if (!type) {
        return "--";
      }
      return train_type(type);
    },
  },

  components: {
    "tea-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-verify": () => import("@/components/Tips/reviewDialog"),
    "yioks-status": () => import("@/components/Tips/Status"),
    BlackListDialog: () => import("@/components/Tips/addBlackList"),
    "yioks-dialog": () => import("@/components/Tips/Dialog"),
    "add-dialog": () => import("@/views/Documents/components/AddDialog"),
    "edit-enter-enroll": () =>
      import("@/components/Qualification/edit-enter-enroll"),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/nav_filter'
.recordNav, .recordMain
  flex 1 1 auto
  height 100%
.recordNav
  display flex
  justify-content space-between
  align-items center
  padding 0 12px 0 0
  font-size $font_size_big
  .audit
    display flex
    justify-content center
    align-items center
    padding 5px 15px
    font-size 16px
    background-color $color_suc
    cursor pointer
.recordMain
  width 100%
  padding 25px 0 25px 0
  background-color $block_bg_color_base
  .Info
    padding 0 0 0 40px
    height 550px
    .mainInfo
      padding-right 40px
      padding-top 5px
      .zuxie-btn
        background none
        border 1px solid
        width 115px
        padding 10px 4px
        &:hover
          background $color_primary
      .perInfo, .recordInfo
        position relative
        margin-bottom 40px
        border 1px solid $color_white
        .score-row
          border-bottom 1px solid $color_white
          .score-table
            .row
              border-bottom 1px solid $color_white
              display flex
              &:last-child
                border-bottom none
              .score-col
                text-align center
                border-left 1px solid $color_white
                flex auto
                &:first-child
                  border-left none
                p
                  margin 10px
                  font-size $font_size_medium
                  word-break break-all
                  &.score-note
                    text-align left
          &:last-child
            border-bottom none
          .score-col
            text-align center
            border-left 1px solid $color_white
            &:first-child
              border-left none
            p
              margin 10px
              font-size $font_size_medium
              word-break break-all
              &.score-note
                text-align left
        .dashed-line
          width 100%
          position absolute
          bottom -22px
          left 0
          border 1px dashed $color_white
        &:last-child
          margin-bottom 0
      .tbodyWrap
        .tbody
          .rankInfo
            width 100%
            margin-bottom 20px
            position relative
            border 1px solid $color_white
            .score-row
              border-bottom 1px solid $color_white
              .score-table
                .row
                  border-bottom 1px solid $color_white
                  display flex
                  &:last-child
                    border-bottom none
                  .score-col
                    text-align center
                    border-left 1px solid $color_white
                    flex auto
                    &:first-child
                      border-left none
                    p
                      margin 10px
                      font-size $font_size_medium
                      word-break break-all
                      &.score-note
                        text-align left
              &:last-child
                border-bottom none
              .score-col
                text-align center
                border-left 1px solid $color_white
                &:first-child
                  border-left none
                p
                  margin 10px
                  font-size $font_size_medium
                  word-break break-all
                  &.score-note
                    text-align left
            .bz
              .score-col
                text-align left
            .dashed-line
              width 100%
              position absolute
              bottom -22px
              left 0
              border 1px dashed $color_white
          .tr
            display flex
            margin 0 0 20px
            .detail
              flex 1 1 auto
              padding 10px
              border 1px solid $color_white
              .title
                font-size 20px
                color $color_suc
                cursor pointer
              .blockWrap
                display flex
                justify-content space-between
                .left
                  flex 1 1 auto
                  .wrap
                    margin 5px 0 0
                    display flex
                    .imgWrap
                      flex 0 0 auto
                      width 135px
                      height 100px
                      position relative
                      img
                        width 100%
                        height 100%
                    .infoWrap
                      padding 0 0 0 20px
                      flex 1 1 auto
                      display flex
                      flex-direction column
                      justify-content space-around
                      font-size $font_size_medium
                      p
                        max-width 445px
                        white-space nowrap
                        overflow hidden
                        text-overflow ellipsis
                .right
                  padding 20px 0 0
                  display flex
                  justify-content center
                  .btn
                    width 100px
                    height 40px
                    display flex
                    justify-content center
                    align-items center
                    font-size $font_size_big
                    line-height $font_size_big
                    background-color $color_suc
                    cursor pointer
                    user-select none
      .title
        display flex
        margin-bottom 10px
        .titleInfo
          margin-left 10px
          font-size 18px
          line-height 1.6
      .timeline
        display block
        padding-left 3px
        .timeline-item
          position relative
          padding-bottom 20px
          .item_tail
            position absolute
            top 36px
            bottom 6px
            left 16px
            // height 100%
            border-left 2px solid #cccccc
          .item_node
            position absolute
            background-color #fff
            color #333
            border 1px solid #fff
            border-radius 50%
            // left -2px
            width 36px
            height @width
            font-size 12px
            display flex
            align-items center
            text-align center
            justify-content center
          .item_wrap
            position relative
            padding-left 50px
            top -3px
            .timestamp
              display flex
              // align-items center
              line-height 1
              margin-bottom 5px
              font-size 15px
              .audit_people
                flex 1
                text-align right
                margin-left 10px
            .item_cont
              display block
              background-color #fff
              color #333
              padding 10px
              border-radius 4px
              border 1px solid #cccccc
              overflow hidden
              font-size 15px
              box-shadow 0 2px 12px 0 rgba(255, 255, 255, 0.1)
      .intro_data
        border 1px dashed $color_white
        padding-left 370px
        height 12px
        font-size 16px
        margin-bottom 20px
      .el-tag + .el-tag
        margin-left 10px
      .button-new-tag
        margin-left 10px
        height 32px
        line-height 30px
        padding-top 0
        padding-bottom 0
      .input-new-tag
        width 90px
        margin-left 10px
        vertical-align bottom
</style>
<style lang="stylus">
.tag_tag
  height auto
  white-space normal
</style>
